import { JSX, KeyboardEvent } from "react";

import { SxProps, TextField, Theme } from "@mui/material";

interface ITextFieldSimple {
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  sx?: SxProps<Theme>;
  multiline?: boolean;
  rows?: number;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  label?: string;
  ariaLabel?: string;
  onBlur?: (value: string) => void;
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void;
}
export const TextFieldSimple = ({
  value,
  onChange,
  type,
  sx,
  multiline,
  rows,
  error,
  disabled,
  helperText,
  label,
  ariaLabel,
  onBlur,
  onKeyDown,
}: ITextFieldSimple): JSX.Element => {
  const defaultSx: SxProps<Theme> = {};
  return (
    <TextField
      helperText={helperText}
      error={error}
      multiline={multiline}
      rows={rows}
      variant="outlined"
      size="small"
      type={type || "text"}
      label={label}
      value={value}
      onBlur={(e) => {
        onBlur?.(e.target.value);
      }}
      onKeyDown={(e) => {
        onKeyDown?.(e);
      }}
      onChange={onChange}
      sx={{ ...defaultSx, ...sx }}
      disabled={disabled}
      slotProps={
        ariaLabel ? { htmlInput: { "aria-label": ariaLabel } } : undefined
      }
    />
  );
};
